module.exports = __webpack_public_path__ + "static/media/Pic-04.f37fb2c8.png";